import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { AddCostEventPage } from "src/components/views/erp/common/costEvents/AddCostEventPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/common/addCostEvent")({
	staticData: { title: i18n.t("cost_entry"), legacyViewKey: "addCostEventPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <AddCostEventPage />;
}
